__turbopack_context__.v({
  "button": "FormatSelector-module__scw3pa__button",
  "container": "FormatSelector-module__scw3pa__container",
  "formatContainer": "FormatSelector-module__scw3pa__formatContainer",
  "title": "FormatSelector-module__scw3pa__title",
});
